export default {
  state: {
    getApplications: [],
    getCompaniesCustomizedRates: [],
    getOriginsCustomizedRates: [],
    getDestinationsCustomizedRates: [],
    getHistoryCustomizedRates: [],
    getTariffCustomizedRates: [],
    getPricesListsByCarrier: []
  },

  getters: {
    getApplications: (state) => state.getApplications,
    getCompaniesCustomizedRates: (state) => state.getCompaniesCustomizedRates,
    getOriginsCustomizedRates: (state) => state.getOrigins,
    getDestinationsCustomizedRates: (state) => state.getDestinations,
    getHistoryCustomizedRates: (state) => state.getHistoryCustomizedRates,
    getTariffCustomizedRates: (state) => state.getTariffCustomizedRates,
    getPricesListsByCarrier: (state) => state.getPricesListsByCarrier
  },

  mutations: {
    setApplications(state, val) {
      state.getApplications = {
        rows: val.rows.map((el) => ({ ...el, text: el.name }))
      }
    },
    setCompaniesCustomizedRates(state, val) {
      state.getCompaniesCustomizedRates = {
        rows: val.rows.map((el) => ({ ...el, text: el.name }))
      }
    },
    setOriginsCustomizedRates(state, val) {
      state.getOriginsCustomizedRates = {
        rows: val.rows.map((el) => ({ ...el, text: el.name }))
      }
    },
    setDestinationsCustomizedRates(state, val) {
      state.getDestinationsCustomizedRates = {
        rows: val.rows.map((el) => ({ ...el, text: el.name }))
      }
    },
    setHistoryCustomizedRates(state, val) {
      state.getHistoryCustomizedRates = {
        rows: val.rows.map((el) => ({...el, text: el.name }))
      }
    },
    setTariffCustomizedRates(state, val) {
      state.getTariffCustomizedRates = {
        rows: val.rows.map((el) => ({...el, text: el.name }))
      }
    },
    setPricesListsByCarrier(state, val) {
      state.getPricesListsByCarrier = {
        rows: val.rows.map((el) => ({...el, text: el.name }))
      }
    }
  }
}
